const INTERNAL_INSTITUTION = 'senapred'

export const restUser = {
  data() {
    return {
      user: {
        id_groups: [],
        firstname: '',
        lastname: '',
        username: '',
        login: '',
        region: '',
        es_externo: false,
        institucion: INTERNAL_INSTITUTION,
        cargo: '',
        telefono: '',
        genero: '',
        permissions: {
          users: false,
          layers: false,
          geo: false,
          maps: false,
          //permiso visor activado por defecto segun observacion SENAPRED 06/2026 ("2. Se debe dejar activado, por defecto, el ticket Visor.")
          visor: true,
          annotation: false,
          documents: false,
          monitoring: false,
          wiki: false,
          terrain: {
            manage: false,
            respond: false,
            review: false,
            publish: false
          }
        }
      },
      users: [],
      regiones: [
        'Nacional',
        'Arica y Parinacota',
        'Tarapacá',
        'Antofagasta',
        'Atacama',
        'Coquimbo',
        'Valparaíso',
        'Metropolitana de Santiago',
        "Libertador General Bernardo O'Higgins",
        'Maule',
        'Ñuble',
        'Biobío',
        'La Araucanía',
        'Los Ríos',
        'Los Lagos',
        'Aysén del General Carlos Ibáñez del Campo',
        'Magallanes y de la Antártica Chilena'
      ],
      generos: ['Femenino', 'Masculino', 'Otro', 'Prefiere no decir']
    }
  },
  methods: {
    syncInstitutionWithUserType() {
      if (this.user.es_externo) {
        if (this.user.institucion === INTERNAL_INSTITUTION) {
          this.user.institucion = ''
        }
        return
      }
      this.user.institucion = INTERNAL_INSTITUTION
    },
    getUser() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/users/${this.$route.params.idUser}`)
        .then((response) => {
          this.user = response.data
          // Mantener vacío el dato real para que el formulario de edición no
          // convierta la etiqueta visual "No posee login" en un valor editable.
          this.$set(this.user, 'login', response.data.login || '')
          this.actualUsername = response.data.username
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    getUsersPages(page, search = '', sortKey = '', sortOrder = 'asc', size = 10, status = 'todos') {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)
      if (status !== 'todos') params.set('status', status)

      this.$http.get(`${backendurl}api/v1/users?${params.toString()}`)
        .then((response) => {
          this.users = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    // Estado de inactividad (amarillo/rojo) de los usuarios visibles. Va aparte
    // del listado porque la tabla se alimenta de tres endpoints distintos.
    // Un fallo acá deja la tabla sin colores pero nunca la rompe.
    getUsersInactivityFlags(ids) {
      if (!ids.length) {
        this.inactivityFlags = {}
        return
      }
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/users/inactivity-flags?ids=${ids.join(',')}`)
        .then((response) => {
          this.inactivityFlags = response.data || {}
        })
        .catch((error) => {
          console.log(error)
          this.inactivityFlags = {}
        })
    },
    getUsersByGroup(page, idGroup, search = '', sortKey = '', sortOrder = 'asc', size = 10, status = 'todos') {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)
      if (status !== 'todos') params.set('status', status)

      this.$http.get(`${backendurl}api/v1/groups/${idGroup}/users?${params.toString()}`)
        .then((response) => {
          this.users = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => {          // Previously missing — silent failure on group-filtered fetch
          console.log(error)
          this.message = error.response.data.message
        })
    },
    // Devuelve la promesa para que la vista pueda mostrar el estado de envío:
    // el alta espera al correo (QA-13) y puede tardar varios segundos.
    postUser() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.post(`${backendurl}api/v1/users`, this.user)
        .then((response) => {
          // La contraseña temporal solo viaja por correo (QA-13) y el administrador
          // nunca la ve. Si el envío falló, el usuario quedó creado sin forma de
          // entrar, así que hay que decirlo y ofrecer la salida.
          this.$store.dispatch('toast/show', response.data.email_sent
            ? {
              message: `Usuario creado. Se envió la contraseña temporal a ${response.data.username}`,
              type: 'success'
            }
            : {
              message: `Usuario creado, pero no se pudo enviar el correo a ${response.data.username}. Genera una contraseña temporal desde su ficha para darle acceso.`,
              type: 'error'
            })
          this.$router.push(`/usuarios/${response.data.id}/asignar-mapas`)
        })
        .catch((error) => {
          console.log(error)
          // Fallas de red no traen error.response
          this.message = (error.response && error.response.data && error.response.data.message) || 'No fue posible crear el usuario.'
        })
    },
    putUserStatus(status) {
      const backendurl = this.$store.getters.backendurl
      return this.$http.put(`${backendurl}api/v1/users/${this.$route.params.idUser}/status`, { status })
    },
    putUsersBulkStatus(ids, status) {
      const backendurl = this.$store.getters.backendurl
      return this.$http.put(`${backendurl}api/v1/users/bulk/status`, { ids, status })
    },
    fetchAllUserIdsForBulk(groupId, search, status) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (search) params.set('search', search)
      if (status !== 'todos') params.set('status', status)
      const qs = params.toString()
      const url = groupId && groupId !== 'todas'
        ? `${backendurl}api/v1/groups/${groupId}/users/${qs ? '?' + qs : ''}`
        : `${backendurl}api/v1/users/${qs ? '?' + qs : ''}`
      return this.$http.get(url).then(r => (r.data || []).map(u => u.id))
    },
    putUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.put(`${backendurl}api/v1/users/${this.$route.params.idUser}`, this.user)
        .then(() => {
          this.$router.push(`/usuarios/${this.$route.params.idUser}`)
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    // Inventario de datos propios del usuario, para mostrarlo antes de confirmar
    // el borrado (QA-04). Devuelve los contadores en vez de guardarlos en el
    // mixin: solo la vista de eliminar los necesita.
    getUserDeleteImpact() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/users/${this.$route.params.idUser}/delete-impact`)
        .then(response => response.data)
    },
    deleteUser() {
      const backendurl = this.$store.getters.backendurl
      this.$http.delete(`${backendurl}api/v1/users/${this.$route.params.idUser}`)
        .then(() => {
          this.$router.push('/usuarios')
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    }
  }
}
